__turbopack_context__.v({
  "body": "IFrameExplanation-module__fJJBoG__body",
  "callToAction": "IFrameExplanation-module__fJJBoG__callToAction",
});
